import jquery from 'jquery';
import slick from './../../vendor/jquery.slick.1.8.0.min';

export default (function($) {

  /**
   * Sets up a hero slider
   *
   * @param {jQuery} $el
   */
  return function HeroSlider(options) {

    if (options && options.container) {
      $(options.container).slick({
        autoplay: true,
        arrows: false,
        dots: true,
        fade: true,
        speed: 1800,
        useCSS: true,
        zIndex: 3,
        responsive: [
          {
            breakpoint: 768,
            settings: {
              fade: false,
              speed: 600
            }
          }
        ]
      });
    }
  };
})(jquery);